import logo from './logo.svg';

import './App.css';

function App() {
  return (
    <div className="App">
      <img src={logo} className='App-logo' alt="logo" />
    </div>
  );
}

export default App;
